import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  FaRegFrown,
  FaRegSmile,
} from "react-icons/fa";

export default function TutorialFeedbackCard({
  feedback,
  tutorialId,
  tutorialVersion,
  onFeedback,
}) {
  const [answer, setAnswer] =
    useState(null);

  const [submitting, setSubmitting] =
    useState(false);

  const storageKey = useMemo(
    () =>
      `tutorial-feedback-${tutorialId}-${tutorialVersion}`,
    [
      tutorialId,
      tutorialVersion,
    ]
  );

  useEffect(() => {
    try {
      const storedAnswer =
        localStorage.getItem(
          storageKey
        );

      if (storedAnswer) {
        setAnswer(storedAnswer);
      }
    } catch {
      // Le stockage local peut être
      // indisponible sur certains appareils.
    }
  }, [storageKey]);

  if (!feedback?.enabled) {
    return null;
  }

  const handleAnswer = async (
    selectedAnswer
  ) => {
    try {
      setSubmitting(true);

      if (onFeedback) {
        await onFeedback(
          selectedAnswer
        );
      }

      setAnswer(selectedAnswer);

      try {
        localStorage.setItem(
          storageKey,
          selectedAnswer
        );
      } catch {
        // Le feedback reste affiché
        // pendant la session.
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="rounded-[26px] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-6">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-900 dark:text-white">
            {feedback.question ||
              "Ce tutoriel vous a-t-il aidé ?"}
          </h2>

          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            {feedback.description}
          </p>
        </div>

        {answer ? (
          <div className="rounded-2xl bg-emerald-50 px-5 py-3 text-sm font-semibold text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300">
            Merci pour votre réponse.
          </div>
        ) : (
          <div className="flex gap-3">
            <button
              type="button"
              disabled={submitting}
              onClick={() =>
                handleAnswer("oui")
              }
              className="inline-flex items-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-emerald-700 disabled:opacity-50"
            >
              <FaRegSmile />
              Oui
            </button>

            <button
              type="button"
              disabled={submitting}
              onClick={() =>
                handleAnswer("non")
              }
              className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
            >
              <FaRegFrown />
              Pas vraiment
            </button>
          </div>
        )}
      </div>
    </section>
  );
}